export interface Instructor {
  id: string
  name: string
  role: string
  image: string
}

export const instructors: Instructor[] = [
  {
    id: 'mark-kanaar',
    name: 'Master Mark Kanaar',
    role: 'Owner / Instructor',
    image:
      'https://static.wixstatic.com/media/a09ac0_2de382b388f54533893cf9a7f204b6e4~mv2.jpg',
  },
  {
    id: 'daniel-foster',
    name: 'Master Daniel Foster',
    role: 'Bridgeport Instructor • Tang Soo Do Master',
    image:
      'https://static.wixstatic.com/media/fcd869_3b809ebd4a3742aa8171ba6d0ebccdd1~mv2.png',
  },
  {
    id: 'deb-foutch',
    name: 'Deb Foutch',
    role: 'Bridgeport / Caro Instructor',
    image:
      'https://static.wixstatic.com/media/fcd869_24216ad361aa46d98418833b874c6011~mv2.jpg',
  },
  {
    id: 'matt-foutch',
    name: 'Matt Foutch',
    role: 'Bridgeport / Caro Instructor',
    image:
      'https://static.wixstatic.com/media/fcd869_1e7bb9960a3e4e678807d51415dfc4bb~mv2.jpg',
  },
  {
    id: 'troy-foutch',
    name: 'Troy Foutch',
    role: 'Bridgeport / Caro Instructor',
    image:
      'https://static.wixstatic.com/media/fcd869_6fb39f864aa54529a41e75773bb7be1d~mv2.jpg',
  },
  {
    id: 'anna-garcia',
    name: 'Anna Garcia',
    role: 'Bridgeport / Caro Instructor',
    image:
      'https://static.wixstatic.com/media/fcd869_8881ad623ae5468d994434b155b36813~mv2.jpg',
  },
  {
    id: 'chad-kilbourn',
    name: 'Chad Kilbourn',
    role: 'Midland Instructor',
    image:
      'https://static.wixstatic.com/media/fcd869_fef2144520cb47158903bf1766541371~mv2.jpg',
  },
  {
    id: 'roxy-kilbourn',
    name: 'Roxy Kilbourn',
    role: 'Midland Instructor',
    image:
      'https://static.wixstatic.com/media/fcd869_72a6286ad5504735a7ab58368cb2c6a7~mv2.jpg',
  },
  {
    id: 'eric-reynolds',
    name: 'Master Eric Reynolds',
    role: 'Midland Instructor',
    image:
      'https://static.wixstatic.com/media/fcd869_e23061be7618436690f5ef3820ccaa2c~mv2.jpg',
  },
  {
    id: 'joey-skutt',
    name: 'Joey Skutt',
    role: 'Midland Instructor',
    image:
      'https://static.wixstatic.com/media/fcd869_b684b6fb5ea5492eb14fd61440baade3~mv2.jpg',
  },
  {
    id: 'alec-strickland',
    name: 'Alec Strickland',
    role: 'Bridgeport Instructor',
    image:
      'https://static.wixstatic.com/media/a09ac0_727ce1b3973b4e6ca9a8d74369636bce~mv2.jpg',
  },
  {
    id: 'bob-wegner',
    name: 'Bob Wegner',
    role: 'Instructor',
    image:
      'https://static.wixstatic.com/media/fcd869_71172868f156450b846071840e1f2aa0~mv2.jpg',
  },
  {
    id: 'lucas-chaddah',
    name: 'Lucas Chaddah',
    role: 'Bridgeport Instructor',
    image:
      'https://static.wixstatic.com/media/a09ac0_2ebb4f47804b4d8382c5831e49a6739b~mv2.jpg',
  },
  {
    id: 'joy-von-matt',
    name: 'Joy Von Matt',
    role: 'Midland Instructor / Aerobics',
    image:
      'https://static.wixstatic.com/media/a88700_02c3331882224bc1a65f167b4b23a6b2~mv2.jpg',
  },
  {
    id: 'audrey-martin',
    name: 'Audrey Martin',
    role: 'Midland Instructor',
    image:
      'https://static.wixstatic.com/media/a88700_39c82ccceccf4f0aa37a7864f0cf6726~mv2.jpeg',
  },
]
